import React from 'react';

function Intro() {
  return (
    <section className="page-intro section-padding pb-0">
      <div className="container">
        <div className="row">
          {/* Full Width - Content */}
          <div className="col-lg-12">
            <div className="cont">
              <h1 className="mb-20">
                Leading Business Setup Company in <span className='main-color'>Dubai</span> 
              </h1>
              <p>
                Bizdoc is a trusted name for business setup services in Dubai, supporting entrepreneurs,
                investors, and corporations with hassle-free solutions. Our mission is to simplify company
                formation in Dubai and across the Emirates, so you can focus on growth while we take care
                of compliance.
              </p>
              <p>
                We specialize in PRO services, document attestation, visa services, <a className='main-color' href="/golden-visa-services-in-dubai">Golden Visa Services in Dubai</a>,
                bank account opening, tax & compliance, trademark registration, and legal solutions. With our
                expert guidance and deep knowledge of Dubai government regulations, Bizdoc delivers transparency,
                speed, and reliability.
              </p>
              <p>
                Whether you are a startup, SME, or multinational, we provide the right solutions to launch
                and expand your business in the Dubai.
              </p>

              {/* Enhanced Content Sections */}
              <h4 className="mt-30">Business Setup Services in Dubai</h4>
              <p>
                Starting a business in Dubai can be complex, but with Bizdoc, it's seamless. We offer comprehensive 
                business setup services in Dubai, including company registration, licensing, and PRO services. Our 
                experts guide you through every step, ensuring your business is compliant with all UAE regulations.
              </p>

              <h4 className="mt-20">Legal Services in Dubai</h4>
              <p>
                Our team also provides expert legal services in Dubai, helping you with document attestation, 
                contracts, and corporate legal compliance. Whether you need legal translation services in Dubai 
                or advice on regulatory requirements, Bizdoc is your trusted partner.
              </p>

              <h4 className="mt-20">Company Formation Dubai</h4>
              <p>
                We specialize in company formation in Dubai, assisting clients in both Free Zone and Mainland setups. 
                From business registration in Dubai to obtaining approvals, visas, and permits, our services cover 
                every aspect of starting and growing your business.
              </p>

              <h4 className="mt-20">Business Support in Dubai</h4>
              <p>
                Beyond setup, we offer ongoing business support in Dubai, including accounting, tax compliance, 
                visa services, and corporate consulting. Our goal is to ensure your business runs smoothly, allowing 
                you to focus on growth and expansion.
              </p>

              {/* Mission & Vision */}
              <h4 className="mt-30">Mission</h4>
              <p>
                At Bizdoc, our mission is to simplify <a className='main-color' href="/business-setup-in-dubai-a-complete-guide">business setup in Dubai</a> by providing entrepreneurs,
                investors, and companies with fast, reliable, and transparent services. We aim to remove the
                complexities of company formation, visas, PRO support, and compliance so our clients can focus
                on building and growing their business with confidence.
              </p>

              <h4 className="mt-20">Vision</h4>
              <p>
                Our vision is to become the most trusted business setup company in Dubai, recognized for making
                business easy, accessible, and successful for everyone—from startups to global enterprises.
                We strive to be the first choice for those seeking corporate services, Golden Visa solutions,
                and end-to-end business support in the Dubai.
              </p>

              <h4 className="mt-20">Why Choose Bizdoc</h4>
              <p>
                Bizdoc is your trusted partner for business setup in Dubai, offering everything from company formation,
                trade licenses, and PRO services to visa processing, bank account opening, and document attestation.
                We make complex procedures simple so you can focus on building your business.
              </p>

              <h4 className="mt-20">Our Business Support & Visa Services in Dubai</h4>
              <p>
                At Bizdoc, we offer a full suite of business setup services in Dubai, backed by corporate support and
                legal expertise. Our services include:
              </p>
              <ul className="mb-30 about-us-li">
                <li><strong><a className='custom-link' href="/business-setup-services-in-dubai">Business Setup Services in Dubai:</a></strong> Trade licenses, company registration, and incorporation.</li>
                <li><strong><a className='custom-link' href="/pro-services-in-dubai">PRO Services:</a></strong> Government approvals, documentation, and renewals.</li>
                <li><strong><a className='custom-link' href="/document-attestation-services-in-dubai">Document Attestation Services:</a></strong> Certified attestation for corporate, educational, and personal use.</li>
                <li><strong><a className='custom-link' href="/legal-services-in-dubai">Legal Services & Legal Assistance:</a></strong> Expert guidance on contracts, disputes, and compliance cases.</li>
                <li><strong><a className='custom-link' href="/legal-translation-services-in-dubai">Legal Translation Services:</a></strong> Certified translations for contracts, agreements, and certificates.</li>
                <li><strong><a className='custom-link' href="/bank-account-services-in-dubai">Bank Account Opening in Dubai:</a></strong> Support for opening personal and corporate accounts.</li>
                <li><strong><a className='custom-link' href="/family-visa-services-in-dubai">Family Visa Services:</a></strong> Hassle-free visa processing for dependents.</li>
                <li><strong><a className='custom-link' href="/golden-visa-services-in-dubai">Golden Visa Dubai:</a></strong> Eligibility assessment and 10-year residency visa applications.</li>
                <li><strong><a className='custom-link' href="/tax&compliance-services-in-dubai">Tax & Compliance Services:</a></strong> VAT registration, accounting, and auditing.</li>
                <li><strong><a className='custom-link' href="/trademark-registration-services-in-dubai">Trademark Registration:</a></strong> Protect your brand in the Dubai market.</li>
                <li><strong><a className='custom-link' href="/business-support-in-dubai">End-to-End Business Support:</a></strong> From setup to growth, complete corporate solutions.</li>
              </ul>

              {/* FAQ Section */}
              <h4 className="mt-30">Frequently Asked Questions</h4>
              
              <div className="faq-item mb-20">
                <h5 className="faq-question">How to set up a business in Dubai?</h5>
                <p className="faq-answer">
                  Bizdoc provides end-to-end services, from company registration to licensing, visas, and legal compliance, 
                  making business setup in Dubai straightforward and efficient.
                </p>
              </div>

              <div className="faq-item mb-20">
                <h5 className="faq-question">Why choose a business setup company in Dubai?</h5>
                <p className="faq-answer">
                  Navigating Dubai's business regulations can be challenging. A trusted setup company like Bizdoc ensures 
                  compliance, saves time, and provides professional guidance at every step.
                </p>
              </div>

              <div className="faq-item mb-30">
                <h5 className="faq-question">What services does Bizdoc offer in Dubai?</h5>
                <p className="faq-answer">
                  We offer company formation, business setup services, legal support, PRO services, visa assistance, 
                  tax compliance, and ongoing business support.
                </p>
              </div>

              <a href="/services" className="underline main-color mt-20">
                <span className="text">
                  Explore Our Services <i className="ti-arrow-top-right"></i>
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Intro;